module.exports = __webpack_public_path__ + "static/media/img11.aba15d98.jpg";